module.exports = __webpack_public_path__ + "static/img/pipeline-junction-cross_64.7838cd8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pipeline-junction-cross_64.png
// module id = 44Gz
// module chunks = 0